import { useParams } from "react-router-dom";
import { OrderProvider } from "contexts/OrderContext";
import DispatchPage from "../../pages/DispatchPage/DispatchPage";

//wrap DispatchPage with the order context
const DispatchPageWrapper = () => {
  const { orderId } = useParams();

  return (
    <OrderProvider orderId={orderId}>
      <DispatchPage />
    </OrderProvider>
  );
};

export default DispatchPageWrapper;
